document.addEventListener("DOMContentLoaded", function () {
  function handleListVisibility() {
    const isMobile = window.innerWidth <= 768;
    document.querySelectorAll(".show-more-container").forEach((container) => {
      const listItems =
        container.previousElementSibling.querySelectorAll(".list-item");
      const showMoreBtn = container.querySelector(".show-more");
      const showLessBtn = container.querySelector(".show-less");

      // Ensure only 4 items are visible initially
      if (isMobile) {
        listItems.forEach((item, index) => {
          item.classList.toggle("hidden", index >= 4);
          showMoreBtn.classList.remove("hidden");
        });
      } else {
        listItems.forEach((item, index) => {
          item.classList.remove("hidden");
          showMoreBtn.classList.add("hidden");
        });
      }

      // Show or hide buttons based on mobile status

      showLessBtn.classList.add("hidden");

      showMoreBtn.onclick = function () {
        listItems.forEach((item) => item.classList.remove("hidden"));
        showMoreBtn.classList.add("hidden");
        if (!isMobile) showLessBtn.classList.remove("hidden");
      };

      showLessBtn.onclick = function () {
        listItems.forEach((item, index) => {
          item.classList.toggle("hidden", index >= 4);
        });
        showMoreBtn.classList.remove("hidden");
        showLessBtn.classList.add("hidden");
      };
    });
  }
  // Run on page load & resize
  handleListVisibility();
  window.addEventListener("resize", handleListVisibility);
});
